import React from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { resetPassword } from "../../store/iam/operations";
import { isChangingPassword } from "../../store/iam/selectors";
import { ResetPasswordForm } from "../../components/auth";
import { RootState } from "../../store";

type Props = {
    token: string;
    isLoading: boolean;
    resetPassword: (token: string, password: string, navigate: any) => void;
};

function ResetPassword({ token, isLoading, resetPassword }: Props) {
    const navigate = useNavigate();
    const submitForm = (token: string, password: string) => {
        resetPassword(token, password, navigate);
    };

    return <ResetPasswordForm token={token} onSubmit={submitForm} isLoading={isLoading} />;
}

const mapStateToProps = (state: RootState) => ({
    isLoading: isChangingPassword(state)
});

export default connect(mapStateToProps, { resetPassword })(ResetPassword);
